import DropAnchor from "lib/Draggable/DropAnchor";
import { useAttribute } from "lib/hooks";
import { TreeContext } from "pages/Editor";
import { forwardRef, useContext, useState } from "react";
import Schema from "./Schema";

function Div({ style, children, onClick }, ref) {
  const { path, component, context, ...treeProps } = useContext(TreeContext);
  const computedStyle = { ...style };
  const [editing, setEditing] = useState(false);
  const [className] = useAttribute("className", false);
  // console.log(component)
  if (!style.height) computedStyle.height = "300px";
  // if(!style.width) computedStyle.width = '300px';
  function onDoubleClick() {
    setEditing(true);
  }
  const content = <Schema component={children} path={path + ".children"} />;
  const treeApi = {
    ...treeProps,
    context,
    path: path + ".children",
    component: children,
  };
  const props = {};
  if (context === "preview") {
    props.onDoubleClick = onDoubleClick;
  }
  return (
    <div
      style={computedStyle}
      {...props}
      ref={ref}
      onClick={onClick}
      contentEditable={editing}
      className={className}
    >
      {/* prevent contenteditable react children clash */}
      {!editing && (
        <>
          <TreeContext.Provider value={treeApi}>{content}</TreeContext.Provider>
          {!children && (
            <DropAnchor
              path={path + ".children"}
              style={{ width: "100%", height: "100%" }}
            />
          )}
        </>
      )}
    </div>
  );
}

export default forwardRef(Div);
